import React from "react";
import { FaWhatsapp, FaComments } from "react-icons/fa";
import { WHATSAPP_CHAT_URL, WHATSAPP_CHANNEL_URL } from "../../common/constants";

const ContactUs = () => {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "30px 20px",
        lineHeight: "1.7",
        color: "#333",
        textAlign: "left",
      }}
    >
      <h1
        style={{
          marginBottom: "20px",
          fontSize: "2rem",
          color: "#222",
          fontWeight: "600",
          textAlign: "left",
        }}
      >
        Contact Us – Speak Bold with KK
      </h1>

      <p>
        We are always here to help you. If you have any questions, feedback, or
        support requests, feel free to reach out to us. You will receive a
        response within <strong>24–48 hours</strong>.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          fontWeight: "500",
          textAlign: "left",
        }}
      >
        How to Reach Us
      </h2>
      
      <div style={{ marginBottom: "20px" }}>
        <p><strong>Email:</strong> support@speakboldwithkk.com</p>
        <p style={{ marginTop: "10px" }}>
          <strong>WhatsApp:</strong> +91 7470517741
        </p>
      </div>

      <div style={{ display: "flex", gap: "15px", marginTop: "20px", flexWrap: "wrap" }}>
        <a
          href={WHATSAPP_CHAT_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 20px",
            backgroundColor: "#25D366",
            color: "white",
            textDecoration: "none",
            borderRadius: "25px",
            fontSize: "14px",
            fontWeight: "500"
          }}
        >
          <FaWhatsapp size={18} />
          Chat on WhatsApp
        </a>
        
        <a
          href={WHATSAPP_CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 20px",
            backgroundColor: "#075E54",
            color: "white",
            textDecoration: "none",
            borderRadius: "25px",
            fontSize: "14px",
            fontWeight: "500"
          }}
        >
          <FaComments size={16} />
          Join WhatsApp Channel
        </a>
      </div>

      <p style={{ marginTop: "20px", fontSize: "14px", color: "#666" }}>
        For quick responses, we recommend using WhatsApp. You can also join our WhatsApp channel for updates and tips.
      </p>
    </div>
  );
};

export default ContactUs;
